import { Partner } from "client/types";
import { fetchApiData } from "client/utils/fetchApiData";

export default function fetchPartnerBySlug(slug: string): Promise<Partner> {
  return fetchApiData({
    url: `/api/user/partners/s/${slug}`,
  });
}
